import { Text } from '@components/gassan-ui/Typography/Text'
import Portal from '@reach/portal'
import { useRouter } from 'next/router'
import { FC } from 'react'
import { cn } from '@lib/cn'

export const ExitPreview: FC = () => {
  const { isPreview } = useRouter()
  return (
    <>
      {isPreview && (
        <Portal>
          <a
            href="/api/exit-preview"
            className={cn(
              'fixed right-0 top-1/2 z-[99] block translate-y-full -rotate-90 rounded-[2px] bg-white px-4 py-2 opacity-60 shadow-[0_0_4px_#00000042] transition-all duration-200 ease-in-out',
              'hover:opacity-100',
            )}
          >
            <Text variant="micro" className="mb-0">
              Exit preview
            </Text>
          </a>
        </Portal>
      )}
    </>
  )
}
